import { components, ControlProps } from 'react-select';
import SVG from 'react-inlinesvg';
import searchSvg from 'assets/icons/search.svg';

interface CustomControlProps extends ControlProps {
  isDirectSalesCampaignType?: boolean;
}

export const CustomControl = (props: CustomControlProps): React.ReactElement => {
  const { children, isDisabled, isDirectSalesCampaignType, ...controlProps } = props;

  const isProgrammaticStyles = isDisabled ? 'text-neutral-400' : 'text-neutral-600';

  return (
    <components.Control
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...controlProps}
      isDisabled={isDisabled}
    >
      <SVG
        className={`${isDirectSalesCampaignType ? 'text-primary' : isProgrammaticStyles} mr-1.5 flex-shrink-0`}
        src={searchSvg}
      />
      {children}
    </components.Control>
  );
};
